// extracted by mini-css-extract-plugin
export default {"App":"App_App__bgNKV","App-logo":"App_App-logo__G5Nmz","App-logo-spin":"App_App-logo-spin__g0JhV","App-header":"App_App-header__RQqpr","App-link":"App_App-link__Afjqk"};